module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rabb",
      "title": "List of Abbreviations"
    }
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253037756_Contents#abb"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("CDU")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "85%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Christlich Demokratische Union Deutschlands / Christian Democratic Union of Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("CSU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Christlich-Soziale Union in Bayern / Christian Social Union in Bavaria")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("DPs")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Displaced Persons")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("FDP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Freie Demokratische Partei / Free Democratic Party")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("FRG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Federal Republic of Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("GDR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("German Democratic Republic")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("HNO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hrvatski Narodni Odbor / Croatian National Committee")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("HOP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hrvatski Oslobodilački Pokret / Croatian Liberation Movement")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("IRO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("International Refugee Organization")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("NDH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Nezavisna Država Hrvatska / Independent State of Croatia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("SPD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Sozialdemokratische Partei Deutschlands / Social Democratic Party of Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("UDBA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Uprava Državne Bezbednosti / State Security Administration")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("UHNj")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Ujedinjeni Hrvati Njemačke / United Croats of Germany")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("UNHCR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("United Nations High Commissioner for Refugees")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("UNRRA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("United Nations Relief and Rehabilitation Administration"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74decb92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253037756_Abbreviations.vue
// module id = 78
// module chunks = 0